import React from "react";
import { Box, Chip, Tooltip, Typography, alpha, useTheme } from "@mui/material";
import TeamPresenceAvatar from "../../../components/TeamPresenceAvatar";

/**
 * Participantes do canal em uma única linha (scroll horizontal quando necessário).
 */
const TeamChannelMemberStrip = ({ members = [], currentUserId, subtle = false, inline = false }) => {
  const theme = useTheme();

  const visible = (members || []).filter(
    (m) =>
      m.participantType !== "user" ||
      String(m.participantId) !== String(currentUserId)
  );

  if (!visible.length) return null;

  return (
    <Box
      sx={{
        px: inline ? 0 : { xs: 1, sm: 2 },
        py: inline ? 0 : subtle ? 0.35 : 0.6,
        borderBottom: inline || subtle ? 0 : 1,
        borderColor: alpha(theme.palette.divider, subtle ? 0 : 0.35),
        bgcolor: inline || subtle ? "transparent" : alpha(theme.palette.primary.main, 0.015),
        overflow: "hidden",
        minWidth: inline ? 0 : undefined,
        flex: inline ? 1 : undefined,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          flexWrap: "nowrap",
          overflowX: "auto",
          overflowY: "hidden",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          "&::-webkit-scrollbar": { display: "none" },
          WebkitOverflowScrolling: "touch",
        }}
      >
        {visible.map((m) => {
          const key = `${m.participantType}-${m.participantId}`;
          const label = m.displayName || "—";

          if (m.participantType === "user") {
            return (
              <Tooltip key={key} title={label} placement="top">
                <Chip
                  size="small"
                  avatar={
                    <TeamPresenceAvatar
                      userId={m.participantId}
                      src={m.avatarUrl}
                      name={label}
                      size={20}
                      dotSize={6}
                      showDot
                    />
                  }
                  label={
                    <Typography component="span" variant="caption" noWrap sx={{ maxWidth: 120 }}>
                      {label}
                    </Typography>
                  }
                  sx={{
                    flexShrink: 0,
                    height: inline ? 24 : 26,
                    bgcolor: alpha(theme.palette.common.black, theme.palette.mode === "dark" ? 0.12 : 0.04),
                    border: "none",
                    boxShadow: "none",
                    "& .MuiChip-avatar": { ml: 0.5 },
                    "& .MuiChip-label": { px: 0.75 },
                  }}
                />
              </Tooltip>
            );
          }

          return (
            <Tooltip key={key} title={label} placement="top">
              <Chip
                size="small"
                label={
                  <Typography component="span" variant="caption" noWrap sx={{ maxWidth: 140 }}>
                    {label}
                  </Typography>
                }
                sx={{
                  flexShrink: 0,
                  height: inline ? 24 : 26,
                  bgcolor: alpha(theme.palette.secondary.main, 0.08),
                  border: "none",
                  color: "text.secondary",
                  "& .MuiChip-label": { px: 1 },
                }}
              />
            </Tooltip>
          );
        })}
      </Box>
    </Box>
  );
};

export default TeamChannelMemberStrip;
